import React,{ Component } from 'react';
import PropTypes from "prop-types";

export default class ErrorBoundary extends Component {
    static propTypes = {
        children: PropTypes.oneOfType([
            PropTypes.node,
            PropTypes.arrayOf(PropTypes.node)
        ]).isRequired,
        boundaryName: PropTypes.string.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            hasError: true,
            error,
            errorInfo
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div align="center">
                    <h4> Error caught in {this.props.boundaryName}. </h4>
                </div>
            );
        }
        return this.props.children;
    }
}